import { defineVariable, type NegotiationVariable } from '../core/define'

/**
 * Resolución de las variables de MONEDA. La moneda viene de la negociación (no del número), por
 * eso se resuelven acá y no son máscaras.
 *
 * El metadato está en `@idc-forms/schemas/variables/document/currency.variables`.
 *
 * Nota: el "valor total con moneda" y "en letras con moneda" se logran con la variable
 * `valor_total` (number) + máscaras `currency`/`currencyLetters`.
 */
export const CURRENCY_VARIABLES: NegotiationVariable[] = [
  defineVariable('moneda_simbolo', (c) => c.currency?.simbolo ?? ''),
  defineVariable('moneda_singular', (c) => c.currency?.singular ?? ''),
  defineVariable('moneda_plural', (c) => c.currency?.plural ?? ''),
  defineVariable('centavo_singular', (c) => c.currency?.centavoSingular ?? ''),
  defineVariable('centavo_plural', (c) => c.currency?.centavoPlural ?? '')
]
